import { View, Text, StyleSheet, TouchableOpacity, Alert } from 'react-native';
import { Trash2, ChevronUp, ChevronDown, GripVertical } from 'lucide-react-native';

interface ExerciseHeaderProps {
  index: number;
  totalExercises: number;
  theme: any;
  onRemove: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
}

export default function ExerciseHeader({
  index,
  totalExercises,
  theme,
  onRemove,
  onMoveUp,
  onMoveDown,
}: ExerciseHeaderProps) {
  return (
    <View style={styles.entryHeader}>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
        {totalExercises >= 2 && (
          <View style={{ flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <TouchableOpacity
              onPress={onMoveUp}
              disabled={index === 0}
              style={{ opacity: index === 0 ? 0.3 : 1 }}
              hitSlop={8}
              accessibilityRole="button"
              accessibilityLabel="Move exercise up">
              <ChevronUp size={18} color={theme.colors.textSecondary} />
            </TouchableOpacity>
            <GripVertical size={14} color={theme.colors.textTertiary} />
            <TouchableOpacity
              onPress={onMoveDown}
              disabled={index === totalExercises - 1}
              style={{ opacity: index === totalExercises - 1 ? 0.3 : 1 }}
              hitSlop={8}
              accessibilityRole="button"
              accessibilityLabel="Move exercise down">
              <ChevronDown size={18} color={theme.colors.textSecondary} />
            </TouchableOpacity>
          </View>
        )}
        <Text style={[styles.entryNumber, { color: theme.colors.accent }]}>
          Exercise {index + 1}
        </Text>
      </View>
      <TouchableOpacity
        onPress={() => {
          Alert.alert(
            'Remove Exercise?',
            'This will delete all sets for this exercise.',
            [
              { text: 'Cancel', style: 'cancel' },
              { text: 'Remove', style: 'destructive', onPress: onRemove },
            ]
          );
        }}
        style={styles.removeBtn}
        accessibilityRole="button"
        accessibilityLabel={`Remove exercise ${index + 1}`}>
        <Trash2 size={20} color={theme.colors.textTertiary} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  entryHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  entryNumber: {
    fontSize: 16,
    fontWeight: '700',
  },
  removeBtn: {
    minWidth: 44,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
